export default "__VITE_ASSET__BB$s2I5O__"